import React from "react"
import PropTypes from "prop-types"
// import { useStaticQuery, graphql } from "gatsby"

// import Header from "./header"
// import Footer from "./footer"

const Layout = ({ children }) => {
  // const data = useStaticQuery(graphql`
  //   query SiteTitleQuery {
  //     site {
  //       siteMetadata {
  //         title 
  //       }
  //     }
  //   }
  // `)

  return (
    <main className="min-h-screen antialiased">
      {/* <Header siteTitle={data.site.siteMetadata?.title || `Title`} /> */}
      <section>
        <main>{ children }</main>
      </section>
      {/* <Footer /> */}
    </main>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
